import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import { v4 as uuidv4 } from "uuid";

const CloudMgmtFaq = () => {
    const webDevelopmentFAQs = [
        {
          "id": uuidv4(),
          "question": "What is the significance of adopting Cloud Management Services for businesses?",
          "answer": " Cloud Management Services empower businesses by providing scalable, flexible, and cost-effective solutions. It enhances operational efficiency, allows for seamless collaboration, and ensures optimal resource utilization."
        },
        {
          "id": uuidv4(),
          "question": "How does Fint Infotech ensure the security of data in the cloud?",
          "answer": " Fint Infotech prioritizes security in Cloud Management. We implement robust encryption protocols, access controls, and regular security audits to safeguard data, ensuring compliance with industry standards and regulations."
        },
        {
          "id": uuidv4(),
          "question": "Can Fint Infotech assist in migrating existing infrastructure to the cloud?",
          "answer": "Absolutely! Fint Infotech specializes in smooth and efficient cloud migration. Our experts assess your current setup, plan a tailored migration strategy, and execute the transition with minimal disruptions."
        },
        {
          "id": uuidv4(),
          "question": "What cloud platforms does Fint Infotech support in its Cloud Management Services?",
          "answer": "Fint Infotech is platform-agnostic, providing Cloud Management Services across major platforms such as AWS, Azure, Google Cloud, and others. Our solutions are tailored to meet the specific requirements of each platform."
        },
        {
          "id": uuidv4(),
          "question": "How does Fint Infotech optimize costs for clients using Cloud Management Services?",
          "answer": " Fint Infotech employs advanced cost optimization strategies, including resource monitoring, auto-scaling, and budget management. This ensures clients only pay for the resources they use, resulting in significant cost savings over time."
        }
      ]
      return (
        <div className='px-5 sm:px-60 mt-10' id="faq">
          <p className='text-[#333e49] text-center font-notosans text-2xl sm:text-4xl font-bold m-10'>Frequently Asked Questions</p>
          {
            webDevelopmentFAQs.map((item) => 
        <Accordion key={item.id}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            className='font-notosans font-bold'
          >
            {item.question}
          </AccordionSummary>
          <AccordionDetails className='font-notosans'>
            {item.answer}
          </AccordionDetails>
        </Accordion>
            )
          }
      </div>
      )
}

export default CloudMgmtFaq